// Api formating objects props to request params

import { isArray } from 'lodash';

export function objectToQueryParams(
  object:
    | {
        [index: string]: string | number | number[] | boolean | undefined;
      }
    | null
    | undefined
): string {
  if (!object) return '';
  return (
    Object.keys(object)
      .map(key => {
        const queryValue = object[key];
        if (queryValue === undefined || queryValue === null || queryValue === '') return undefined;
        return isArray(queryValue)
          ? queryValue?.map(value => key + '=' + value)
          : key + '=' + encodeURIComponent(queryValue);
      })
      .flat()
      .filter(q => q !== undefined)
      .join('&') || ''
  );
}
// to be turned on a test Coverage
// console.log(
//   'search=hey&sort=name&types=1&types=5 : =>  ',
//   objectToQueryParams({ search: 'hey', sort: 'name', types: [1, 5] })
// );

// to be turned on a test Coverage
// console.log(
//   'sort=name&types=1&types=5 : =>  ',
//   objectToQueryParams({  sort: 'name', types: [1, 5] })
// );

// to be turned on a test Coverage
// console.log(
//   "search=hey&id=5&hidden=true : =>",
//   objectToQueryParams({ search: "hey", id: 5, hidden: true })
// );
